// src/admin/pages/AdminProducts.js
import React, { useState, useEffect, useContext, useRef } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaChartLine,
  FaHeartbeat,
  FaCrown,
  FaInfoCircle,
} from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminProducts } from "../../services/adminProducts.api";
import { deleteAdminProduct } from "../../services/adminProducts.api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toggleAdminProductVisibility } from "../../services/adminProducts.api";
import { FaBoxOpen, FaSearch } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { getAdminCategories } from "../../services/adminProducts.api";
import { FaTag } from "react-icons/fa";
import { getProductsAnalytics } from "../../services/productsAnalytics.api";
import {
  TagIcon as TagOutline,
} from "@heroicons/react/24/outline";

import {
  TagIcon as TagSolid,
} from "@heroicons/react/24/solid";

function AdminProducts() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { lang } = useContext(AdminLanguageContext);

    const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const canAccessProducts = isAdmin || perms.can_manage_products;

const renderProductsIcon = (active) => {
  const Icon = active ? TagOutline : TagSolid;

  return (
    <div className="relative w-[18px] h-[18px] flex items-center justify-center">
      <Icon
        className={`
          w-[18px] h-[18px]
          ${active ? "text-[#202223]" : "text-gray-900"}
          transform scale-x-[-1]
        `}
      />
    </div>
  );
};

    const TEXT = {
        EN: {
            title: "Products",
            add: "Add Product",
            search: "Search products...",
            image: "Image",
            analyticsLoading: "Loading analytics...",
            sellThrough: "Sell-through rate",
            inventoryHealth: "Inventory health",
            topProducts: "Top products",
            analyticsHintSell: "Units sold vs current stock",
            analyticsHintHealth: "Healthy active variants",
            analyticsHintTop: "Top-performing product share",
            titleCol: "Title",
            price: "Price",
            sortBy: "Sort by",
            lowestToHighest: "Lowest to highest",
            highestToLowest: "Highest to lowest",
            aToZ: "A → Z",
            zToA: "Z → A",
            stock: "Stock",
            actions: "Actions",
            loading: "Loading products...",
            empty: "No products found.",
            edit: "Edit",
            product: "Product",
            category: "Collection",
            status: "Status",

            priceDetails: "Price Details",
            basePrice: "Base price",
            discount: "Discount",
            amountSaved: "Amount saved",
            finalPrice: "Final price",

            stockDetails: "Stock Details",
            total: "Total",
            noStock: "No stock available",

            editStock: "Edit stock",

            new: "New",
            bestseller: "Bestseller",
            sale: "Sale",

            bulkDeleteText: "You are about to delete multiple products. This action cannot be undone.",

            hiddenBadge: "Hidden",
            delete: "Delete",
            prev: "Prev",
            next: "Next",
            deleteTitle: "Delete Product?",
            deleteText: "This action cannot be undone.",
            cancel: "Cancel",
            count: "Total products",
            all: "All",
            active: "Active",
            hidden: "Hidden",
            sellThroughTooltip:
              "Measures how fast your inventory is selling. It compares total units sold to total available stock (sold + remaining). A higher percentage means your products are selling quickly.",

            inventoryHealthTooltip:
              "Shows how healthy your stock is. It calculates the percentage of variants that have more than 3 items in stock. Low values mean many products are running out or already out of stock.",

            topProductsTooltip:
              "Represents the share of top-performing products. It identifies the highest-selling products and shows how much they dominate your store performance.",
        },
        AR: {
            title: "المنتجات",
            add: "إضافة منتج",
            analyticsLoading: "جاري تحميل التحليلات...",
            sellThrough: "معدل البيع",
            inventoryHealth: "صحة المخزون",
            topProducts: "أفضل المنتجات",
            analyticsHintSell: "الوحدات المباعة مقابل المخزون الحالي",
            analyticsHintHealth: "نسبة المتغيرات النشطة السليمة",
            analyticsHintTop: "حصة المنتجات الأعلى أداءً",
            search: "بحث عن المنتجات...",
            image: "الصورة",
            titleCol: "العنوان",
            price: "السعر",
            stock: "المخزون",
            product: "المنتج",
            category: "الفئة",
            status: "الحالة",

            priceDetails: "تفاصيل السعر",
            basePrice: "السعر الأساسي",
            discount: "الخصم",
            amountSaved: "المبلغ الموفّر",
            finalPrice: "السعر النهائي",

            stockDetails: "تفاصيل المخزون",
            total: "الإجمالي",
            noStock: "لا يوجد مخزون",

            editStock: "تعديل المخزون",

            new: "جديد",
            bestseller: "الأكثر مبيعاً",
            sale: "تخفيض",

            bulkDeleteText: "أنت على وشك حذف عدة منتجات. لا يمكن التراجع عن هذا الإجراء.",

            hiddenBadge: "مخفي",
            actions: "الإجراءات",
            loading: "جاري تحميل المنتجات...",
            empty: "لا توجد منتجات.",
            edit: "تعديل",
            delete: "حذف",
            prev: "السابق",
            next: "التالي",
            deleteTitle: "حذف المنتج؟",
            deleteText: "لا يمكن التراجع عن هذا الإجراء.",
            cancel: "إلغاء",
            count: "إجمالي المنتجات",
            sortBy: "ترتيب حسب",
            lowestToHighest: "من الأقل إلى الأعلى",
            highestToLowest: "من الأعلى إلى الأقل",
            aToZ: "A → Z",
            zToA: "Z → A",
            all: "الكل",
            active: "نشط",
            hidden: "مخفي",
            sellThroughTooltip:
              "يقيس مدى سرعة بيع المخزون. يقارن بين عدد الوحدات المباعة وإجمالي المخزون (المباع + المتبقي). كلما زادت النسبة، زادت سرعة البيع.",

            inventoryHealthTooltip:
              "يوضح مدى صحة المخزون. يتم حساب نسبة المتغيرات التي تحتوي على أكثر من 3 قطع. القيم المنخفضة تعني أن المنتجات على وشك النفاد أو نفدت.",

            topProductsTooltip:
              "يمثل نسبة أفضل المنتجات أداءً. يحدد المنتجات الأكثر مبيعًا ويوضح مدى تأثيرها على أداء المتجر.",
        },
    }[lang];

    const [showToast, setShowToast] = useState(false);

    const [toastMessage, setToastMessage] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [stockOverlay, setStockOverlay] = useState(null);

    const [analyticsOpen, setAnalyticsOpen] = useState(true);
    const [actionsOpen, setActionsOpen] = useState(false);

    const [selectedProducts, setSelectedProducts] = useState([]);

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    const ADMIN_PRODUCTS_PAGE_KEY = "adminProductsCurrentPage";

    const getValidPage = (value) => {
      const n = Number(value || 1);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
    };

    const getInitialPage = () => {
      const urlPage = searchParams.get("page");
      const savedPage = sessionStorage.getItem(ADMIN_PRODUCTS_PAGE_KEY);
      return getValidPage(urlPage || savedPage || 1);
    };

    const [page, setPage] = useState(getInitialPage);

    useEffect(() => {
      const urlPage = searchParams.get("page");
      const savedPage = sessionStorage.getItem(ADMIN_PRODUCTS_PAGE_KEY);
      const nextPage = getValidPage(urlPage || savedPage || 1);

      if (nextPage !== page) {
        setPage(nextPage);
      }

      if (!urlPage && nextPage > 1) {
        setSearchParams((prev) => {
          const params = new URLSearchParams(prev);
          params.set("page", String(nextPage));
          return params;
        });
      }
    }, [searchParams, page, setSearchParams]);

    const goToPage = (nextPage) => {
      const rawNext = typeof nextPage === "function" ? nextPage(page) : nextPage;
      const safePage = getValidPage(rawNext);

      setPage(safePage);

      if (safePage <= 1) {
        sessionStorage.removeItem(ADMIN_PRODUCTS_PAGE_KEY);
      } else {
        sessionStorage.setItem(ADMIN_PRODUCTS_PAGE_KEY, String(safePage));
      }

      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);

        if (safePage <= 1) {
          params.delete("page");
        } else {
          params.set("page", String(safePage));
        }

        return params;
      });
    };

    const didMountFiltersRef = useRef(false);
    const perPage = 10;

    const [priceOverlay, setPriceOverlay] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    const [searchOpen, setSearchOpen] = useState(false);

    const [isHoveringOverlay, setIsHoveringOverlay] = useState(false);

    const [sortOpen, setSortOpen] = useState(false);
    const [sortField, setSortField] = useState("title_en");

    const [visibilityFilter, setVisibilityFilter] = useState("All");

    const [categoryFilter, setCategoryFilter] = useState(null);
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [categories, setCategories] = useState([]);

    const [expandedStock, setExpandedStock] = useState({});

    const [productOverlay, setProductOverlay] = useState(null);
 
    const [analytics, setAnalytics] = useState({
      sell_through: 0,
      inventory_health: 0,
      top_products: 0,
    });

    const [analyticsLoading, setAnalyticsLoading] = useState(true);

    useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".actions-overlay") &&
      !e.target.closest(".actions-button")
    ) {
      setActionsOpen(false);
    }
  };

  if (actionsOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [actionsOpen]);

    useEffect(() => {
  setAnalyticsLoading(true);

  getProductsAnalytics()
    .then((data) => {
      setAnalytics({
          sell_through: Number(data?.sell_through || 0),
          inventory_health: Number(data?.inventory_health || 0),
          top_products: Number(data?.top_products_percentage || 0),
        });
    })
    .catch((err) => {
      console.error("Load products analytics error:", err);
    })
    .finally(() => setAnalyticsLoading(false));
}, []);

    useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".product-overlay") &&
      !e.target.closest(".product-trigger")
    ) {
      setProductOverlay(null);
    }
  };

  if (productOverlay) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [productOverlay]);

    useEffect(() => {
          getAdminCategories()
            .then(setCategories)
            .catch(console.error);
        }, []);

    useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".sort-overlay") &&
      !e.target.closest(".sort-button")
    ) {
      setSortOpen(false);
    }
  };

  if (sortOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [sortOpen]);

useEffect(() => {
  const handleClick = (e) => {
    if (!e.target.closest(".category-dropdown")) {
      setCategoryOpen(false);
    }
  };

  if (categoryOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [categoryOpen]);

useEffect(() => {
  if (!didMountFiltersRef.current) {
    didMountFiltersRef.current = true;
    return;
  }

  goToPage(1);
}, [search, visibilityFilter, categoryFilter, sortBy, sortDirection]);

    useEffect(() => {
  setLoading(true);
  getAdminProducts()
    .then((data) => {
      const mapped = data.map((p) => ({
        ...p,
        title_en: p.name_en,   // ✅ FIX
        price: p.base_price,   // ✅ FIX
      }));
      setProducts(mapped);
    })
    .catch((err) => console.error("Load products error:", err))
    .finally(() => setLoading(false));
}, []);


const toggleProductSelection = (id) => {
  setSelectedProducts((prev) =>
    prev.includes(id)
      ? prev.filter((p) => p !== id)
      : [...prev, id]
  );
};

const toggleSelectAll = () => {
  if (selectedProducts.length === paginated.length) {
    setSelectedProducts([]);
  } else {
    setSelectedProducts(paginated.map((p) => p.id));
  }
};

const bulkToggleVisibility = async () => {
  const selected = products.filter((p) =>
    selectedProducts.includes(p.id)
  );

  const allActive = selected.every((p) => p.is_active === 1);

  await Promise.all(
    selectedProducts.map((id) => toggleAdminProductVisibility(id))
  );

  setProducts((prev) =>
    prev.map((p) =>
      selectedProducts.includes(p.id)
        ? { ...p, is_active: allActive ? 0 : 1 }
        : p
    )
  );

  setSelectedProducts([]);

  setToastMessage(
    allActive
      ? (lang === "EN" ? "Products hidden" : "تم إخفاء المنتجات")
      : (lang === "EN" ? "Products activated" : "تم تفعيل المنتجات")
  );

  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);
};

const confirmBulkDelete = async () => {
  await Promise.all(selectedProducts.map((id) => deleteAdminProduct(id)));

  setProducts((prev) =>
    prev.filter((p) => !selectedProducts.includes(p.id))
  );

  setSelectedProducts([]);
  setDeleteId(null);

  // ✅ toast
  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);
};

const goToAnalytics = () => navigate("/admin/analytics/products");

    const filtered = products.filter((p) => {
  const q = search.toLowerCase();

  const matchesSearch =
    !search ||
    (p.name_en || "").toLowerCase().includes(q) ||
    (p.name_ar || "").toLowerCase().includes(q) ||
    (p.public_id || "").toLowerCase().includes(q) ||
    (p.categories || []).some((c) =>
      typeof c === "string"
        ? c.toLowerCase().includes(q)
        : (c.name_en || "").toLowerCase().includes(q) ||
          (c.name_ar || "").toLowerCase().includes(q)
    ) ||
    (p.variants || []).some((v) =>
      (v.color_name || "").toLowerCase().includes(q)
    );

    
  const matchesVisibility =
    visibilityFilter === "All"
      ? true
      : visibilityFilter === "active"
      ? p.is_active === 1
      : p.is_active === 0;

  // ✅ NEW CATEGORY FILTER
  const matchesCategory =
  !categoryFilter ||
  (p.categories || []).some((c) => {
    const slug =
      typeof c === "string"
        ? c
        : c.slug || c.name_en || c.name_ar;

    return String(slug).toLowerCase() === String(categoryFilter).toLowerCase();
  });

  return matchesSearch && matchesVisibility && matchesCategory;
});



    const sorted = [...filtered].sort((a, b) => {
    const field = sortBy; 

      if (!field) return 0;

      let valueA = a[field];
      let valueB = b[field];

      // 🔥 SPECIAL CASE: stock
      if (field === "stock") {
        const getStock = (p) =>
          (p.variants || []).reduce((sum, v) => sum + Number(v.stock_qty || 0), 0);

        valueA = getStock(a);
        valueB = getStock(b);
      }

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (sortDirection === "asc") return valueA > valueB ? 1 : -1;
      return valueA < valueB ? 1 : -1;
    });

    const totalPages = Math.ceil(sorted.length / perPage);
    const paginated = sorted.slice((page - 1) * perPage, page * perPage);

    const changeSort = (field) => {
        if (sortBy === field) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(field);
            setSortDirection("asc");
        }
    };

    const getSortIcon = (field) => {
        if (sortBy !== field) return <FaSort className="inline opacity-40 ml-1" />;
        return sortDirection === "asc" ? (
            <FaSortUp className="inline ml-1" />
        ) : (
            <FaSortDown className="inline ml-1" />
        );
    };

    const confirmDelete = async () => {
  await deleteAdminProduct(deleteId);

  setProducts((prev) => prev.filter((p) => p.id !== deleteId));

  setDeleteId(null);

  // ✅ toast
  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);
};

const handleToggleVisibility = async (id) => {
  const product = products.find((p) => p.id === id);
  if (!product) return;

  const wasActive = product.is_active === 1; // ✅ capture OLD state

  await toggleAdminProductVisibility(id);

  setProducts((prev) =>
    prev.map((p) =>
      p.id === id ? { ...p, is_active: wasActive ? 0 : 1 } : p
    )
  );

  setToastMessage(
    wasActive
      ? (lang === "EN" ? "Product hidden" : "تم إخفاء المنتج")
      : (lang === "EN" ? "Product activated" : "تم تفعيل المنتج")
  );

  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);
};

  const groupVariantsByColor = (variants = []) => {
  // ✅ 1) DEDUPE: keep only ONE row per variant.id (joins were duplicating it)
  const byId = new Map();

  (variants || []).forEach((v) => {
    if (!v) return;

    const id = v.id != null ? String(v.id) : null;

    // normalize
    const normalized = {
      id,
      color_name: v.color_name || "Unknown",
      color_hex: v.color_hex || "#ccc",
      size: v.size != null ? String(v.size) : "",
      stock_qty: Number(v.stock_qty || 0),
    };

    if (id) {
      // keep first (or keep the bigger qty if you want extra safety)
      if (!byId.has(id)) byId.set(id, normalized);
    } else {
      // fallback if id missing (rare): unique by color+hex+size+qty
      const fallbackKey = `${normalized.color_name}|${normalized.color_hex}|${normalized.size}|${normalized.stock_qty}`;
      if (!byId.has(fallbackKey)) byId.set(fallbackKey, normalized);
    }
  });

  const uniqueVariants = Array.from(byId.values());

  // ✅ 2) GROUP BY COLOR + SUM TOTALS
  const colorsMap = {};

  uniqueVariants.forEach((v) => {
    const cKey = `${v.color_name}|${v.color_hex}`;

    if (!colorsMap[cKey]) {
      colorsMap[cKey] = {
        color_name: v.color_name,
        color_hex: v.color_hex,
        total: 0,
        sizes: [],
      };
    }

    colorsMap[cKey].total += v.stock_qty;
    colorsMap[cKey].sizes.push({ size: v.size, qty: v.stock_qty });
  });


  // ✅ 3) sort sizes nicely
  return Object.values(colorsMap).map((c) => ({
    ...c,
    sizes: c.sizes.sort((a, b) => {
      const na = Number(a.size);
      const nb = Number(b.size);
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      return String(a.size).localeCompare(String(b.size));
    }),
  }));
};

const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

const Tooltip = ({ text }) => (
  <div className="relative group flex items-center">
    <FaInfoCircle className="text-gray-400 text-[13px] cursor-pointer" />

    <div
      className="
      absolute z-50
      bottom-full mb-2
      left-1/2 -translate-x-1/2
      w-[240px]
      px-3 py-2
      text-[12px] leading-relaxed
      bg-black text-white
      rounded-lg
      shadow-lg
      opacity-0 group-hover:opacity-100
      pointer-events-none
      transition-all duration-200
      "
    >
      {text}

      {/* arrow */}
      <div className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-gray-900 rotate-45"></div>
    </div>
  </div>
);

const isVideoFile = (url = "") => {
  const cleanUrl = String(url).split("?")[0].toLowerCase();
  return /\.(mp4|webm|ogg|mov)$/i.test(cleanUrl);
};

const ProductMediaThumb = ({ src, className = "" }) => {
  const mediaSrc = src || "/no-image.png";

  if (isVideoFile(mediaSrc)) {
    return (
      <video
        src={mediaSrc}
        muted
        playsInline
        preload="metadata"
        className={className}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    );
  }

  return (
    <img
      src={mediaSrc}
      className={className}
      alt=""
      onError={(e) => (e.target.src = "/no-image.png")}
    />
  );
};

    return (
        <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all duration-300`}>
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">
                 {!canAccessProducts ? (
    <div className="mt-10 bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold text-lg">
        {lang === "EN"
          ? "You are not allowed to access the Products page."
          : "غير مسموح لك بالدخول إلى صفحة المنتجات."}
      </p>
    </div>
  ) : (
    <>
           {/* PAGE HEADER (SHOPIFY STYLE) */}
<div className="flex items-center justify-between mb-5">

  {/* LEFT SIDE */}
  <div className="mx-1 flex items-center gap-2">

    <div className="flex items-center justify-center w-6 h-6">
  {renderProductsIcon(true)}
</div>

    <div className="flex items-baseline gap-2">
      <h1 className="text-[20px] font-semibold text-gray-900">
        {TEXT.title}
      </h1>
    </div>

  </div>

  {/* RIGHT SIDE */}
<div className="flex items-center gap-2">

  {/* ACTIONS DROPDOWN (SAME AS ORDERS) */}
  <div className="relative">

    <button
      onClick={() => setActionsOpen((v) => !v)}
      className="
      actions-button
      flex items-center gap-1
      h-8 px-3
      bg-[#f6f6f7]
      border border-gray-300
      rounded-lg
      shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
      text-sm font-medium text-gray-900
      hover:bg-gray-100
      active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
      transition
      "
    >
      {TEXT.actions}
      <FiChevronDown className="text-gray-500 text-sm" />
    </button>

    {actionsOpen && (
      <div className={`
        actions-overlay
        absolute ${lang === "AR" ? "left-0" : "right-0"} top-full mt-0.5
        w-48
        bg-white
        border border-gray-300
        rounded-xl
        shadow-[0_20px_40px_rgba(0,0,0,0.12)]
        z-50
        animate-sortOverlay
      `}>

        <button
          onClick={() => {
            setAnalyticsOpen((v) => !v);
            setActionsOpen(false);
          }}
          className="
          flex items-center gap-2
          w-full
          px-3 py-2
          text-sm
          text-gray-900
          hover:bg-gray-100
          transition
          "
        >
          <FaEye className="text-gray-600" />
          {analyticsOpen
            ? (lang === "EN" ? "Hide analytics bar" : "إخفاء شريط التحليلات")
            : (lang === "EN" ? "Show analytics bar" : "إظهار شريط التحليلات")}
        </button>

      </div>
    )}

  </div>

  {/* ADD PRODUCT */}
  <button
    onClick={() => navigate("/admin/products/add")}
    className="
    h-8 px-3
    bg-[#1f1f1f]
    text-white
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]
    text-sm font-medium
    hover:bg-black
    active:shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]
    transition
    flex items-center gap-2
    "
  >
    {TEXT.add}
  </button>

</div>

</div>         

{/* ANALYTICS BAR */}
{analyticsOpen && (
<div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-5">
  {analyticsLoading ? (
    <>
      {[1, 2, 3].map((item) => (
        <div
          onClick={goToAnalytics}
          key={item}
          className="
            bg-white border border-[#e3e3e3] rounded-[14px]
            px-4 py-4
            shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
            animate-pulse
            cursor-pointer
          "
        >
          <div className="h-4 w-24 bg-gray-200 rounded mb-3"></div>
          <div className="h-8 w-20 bg-gray-200 rounded mb-2"></div>
          <div className="h-3 w-40 bg-gray-100 rounded"></div>
        </div>
      ))}
    </>
  ) : (
    <>
      {/* SELL-THROUGH */}
      <div
        onClick={goToAnalytics}
        className="
          bg-white border border-[#e3e3e3] rounded-[14px]
          px-4 py-4 cursor-pointer
          shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
        "
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 text-[13px] font-medium text-gray-500">
              {TEXT.sellThrough}
              <Tooltip text={TEXT.sellThroughTooltip} />
            </div>
            <div className="mt-1 text-[28px] leading-none font-semibold text-gray-900">
              {formatPercent(analytics.sell_through)}
            </div>
            <div className="mt-2 text-[12px] text-gray-500">
              {TEXT.analyticsHintSell}
            </div>
          </div>

          <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
            <FaChartLine className="text-blue-600 text-[16px]" />
          </div>
        </div>

        <div className="mt-4 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-blue-500 transition-all duration-500"
            style={{ width: `${Math.min(analytics.sell_through, 100)}%` }}
          />
        </div>
      </div>

      {/* INVENTORY HEALTH */}
      <div
        onClick={goToAnalytics}
        className="
          bg-white border border-[#e3e3e3] rounded-[14px]
          px-4 py-4 cursor-pointer
          shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
        "
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 text-[13px] font-medium text-gray-500">
              {TEXT.inventoryHealth}
              <Tooltip text={TEXT.inventoryHealthTooltip} />
            </div>
            <div className="mt-1 text-[28px] leading-none font-semibold text-gray-900">
              {formatPercent(analytics.inventory_health)}
            </div>
            <div className="mt-2 text-[12px] text-gray-500">
              {TEXT.analyticsHintHealth}
            </div>
          </div>

          <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center">
            <FaHeartbeat className="text-emerald-600 text-[16px]" />
          </div>
        </div>

        <div className="mt-4 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-emerald-500 transition-all duration-500"
            style={{ width: `${Math.min(analytics.inventory_health, 100)}%` }}
          />
        </div>
      </div>

      {/* TOP PRODUCTS */}
      <div
        onClick={goToAnalytics}
        className="
          bg-white border border-[#e3e3e3] rounded-[14px]
          px-4 py-4 cursor-pointer
          shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
        "
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 text-[13px] font-medium text-gray-500">
              {TEXT.topProducts}
              <Tooltip text={TEXT.topProductsTooltip} />
            </div>
            <div className="mt-1 text-[28px] leading-none font-semibold text-gray-900">
              {formatPercent(analytics.top_products)}
            </div>
            <div className="mt-2 text-[12px] text-gray-500">
              {TEXT.analyticsHintTop}
            </div>
          </div>

          <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center">
            <FaCrown className="text-amber-600 text-[16px]" />
          </div>
        </div>

        <div className="mt-4 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-amber-500 transition-all duration-500"
            style={{ width: `${Math.min(analytics.top_products, 100)}%` }}
          />
        </div>
      </div>
    </>
  )}
</div>
)}

                    <div className="
hidden md:block
bg-white
border border-[#e3e3e3]
rounded-[14px]
overflow-visible
shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
">

{/* TABLE TOP HEADER */}
<div className="relative flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px] overflow-visible">

{/* SORT OVERLAY */}
{sortOpen && (
  <div className={`sort-overlay absolute ${lang === "AR" ? "left-3" : "right-3"} top-full w-47 bg-white border border-gray-200 rounded-xl shadow-[0_30px_30px_rgba(0,0,0,0.15)] z-50 animate-sortOverlay z-[9999]`}>

    {/* SECTION 1 */}
    <div className="px-4 pt-4 text-xs font-semibold uppercase tracking-wide">
       {TEXT.sortBy}
    </div>

    {/* SECTION 2 */}
    <div className="mt-1 text-sm">
      {[
        { label: TEXT.titleCol, value: "title_en" },
        { label: TEXT.price, value: "price" },
        { label: TEXT.stock, value: "stock" },
      ].map((opt) => (
        <label
          key={opt.value}
          className={`flex items-center gap-3 px-3 py-1 cursor-pointer rounded-md hover:bg-gray-100 ${
            sortField === opt.value ? "bg-gray-100 font-medium" : ""
          }`}
        >
          <input
            type="radio"
            checked={sortField === opt.value}
            onChange={() => setSortField(opt.value)}
            className="w-4 h-4 accent-gray-800 cursor-pointer"
          />
          {opt.label}
        </label>
      ))}
    </div>

    <div className="my-2 border-t border-gray-300"></div>

    {/* SECTION 3 */}
    <div className="px-1 pb-1 flex flex-col">

      <button
        onClick={() => {
  setSortBy(null); // 🔥 force reset first
  setTimeout(() => {
    setSortBy(sortField);
    setSortDirection("asc");
  }, 0);
  setSortOpen(false);
}}
        className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-gray-100"
      >
        ↑ {sortField === "price" || sortField === "stock"
                ? TEXT.lowestToHighest
                : TEXT.aToZ}
      </button>

      <button
        onClick={() => {
  setSortBy(null);
  setTimeout(() => {
    setSortBy(sortField);
    setSortDirection("desc");
  }, 0);
  setSortOpen(false);
}}
        className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-gray-100"
      >
        ↓ {sortField === "price" || sortField === "stock"
          ? TEXT.highestToLowest
          : TEXT.zToA}
      </button>

    </div>
  </div>
)}

{/* LEFT SIDE */}
{!searchOpen ? (

  <div className="flex items-center gap-1 relative">

    {[
      { label: TEXT.all, value: "All" },
      { label: TEXT.active, value: "active" },
      { label: TEXT.hidden, value: "hidden" },
    ].map((f) => {
      const active = visibilityFilter === f.value;

      return (
        <button
          key={f.value}
          onClick={() => setVisibilityFilter(f.value)}
          className={`
            px-3 py-[5px]
            text-[13px] font-medium
            rounded-md
            transition
            ${
              active
                ? "bg-gray-200 text-gray-900"
                : "text-gray-600 hover:bg-gray-200"
            }
          `}
        >
          {f.label}
        </button>
      );
    })}

            <div className="relative category-dropdown">
                <button
                  onClick={() => setCategoryOpen((v) => !v)}
                  className="
                    w-8 h-8 flex items-center justify-center
                    bg-white rounded-md
                    hover:bg-gray-100 transition
                    text-gray-900
                  "
                >
                  +
                </button>

                {categoryOpen && (
                  <div
                    className={`absolute top-full mt-2 ${
                      lang === "AR" ? "left-0" : "right-0"
                    } w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-50`}
                  >
                    {/* HEADER */}
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 border-b">
                      {lang === "EN" ? "Filter by collection" : "تصفية حسب الفئة"}
                    </div>

                    {/* ALL OPTION */}
                    <button
                      onClick={() => {
                        setCategoryFilter(null);
                        setCategoryOpen(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                    >
                      {lang === "EN" ? "All categories" : "كل الفئات"}
                    </button>

                    {/* CATEGORY LIST */}
                    <div className="max-h-60 overflow-y-auto">
                      {categories.map((c) => {
                        const label = lang === "AR" ? c.name_ar : c.name_en;

                        return (
                          <button
                            key={c.id}
                            onClick={() => {
                              setCategoryFilter(c.slug); // keep EN internally
                              setCategoryOpen(false);
                              goToPage(1); // reset pagination
                            }}
                            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                          >
                            {label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
                {categoryFilter && (
                  <div className="flex items-center gap-2 ml-2">
                    <div className="flex items-center gap-2 px-3 py-[5px] bg-gray-200 rounded-md text-sm font-medium">
                      
                      {/* label */}
                      <span>
                        {
                          categories.find(c => c.slug === categoryFilter)?.[
                              lang === "AR" ? "name_ar" : "name_en"
                            ] || ""
                        }
                      </span>

                      {/* clear button */}
                      <button
                        onClick={() => setCategoryFilter(null)}
                        className="text-gray-600 hover:text-black text-xs"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}

                  </div>

                ) : (

                  <div className="flex items-center gap-3 w-full">

                    <div className="
                            flex items-center justify-between
                            flex-1
                            h-8
                            px-3
                            bg-white
                            border border-gray-300
                            rounded-lg
                            shadow-sm
                            focus-within:border-gray-500
                            focus-within:ring-2
                            focus-within:ring-gray-200
                            transition
                            ">

                      <div className="flex items-center gap-2 flex-1">
                        <FaSearch className="text-gray-400 text-sm" />
                        <input
                          autoFocus
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder={TEXT.search}
                          className="flex-1 outline-none text-sm"
                        />
                      </div>

                      <button
                        onClick={() => {
                          setSearch("");
                          setSearchOpen(false);
                        }}
                        className="w-5 h-5 flex items-center justify-center rounded-full border border-gray-500 text-gray-500 hover:bg-gray-100"
                      >
                        ✕
                      </button>

                    </div>

                    <button
                      onClick={() => {
                        setSearch("");
                        setSearchOpen(false);
                      }}
                      className="px-3 h-8 bg-white border border-gray-300 rounded-lg shadow-sm text-sm font-medium mx-1"
                    >
                      {TEXT.cancel}
                    </button>

                  </div>

                )}

                {/* RIGHT SIDE */}
                <div className="flex items-center gap-2">

                {selectedProducts.length > 0 && (() => {
                  const selected = products.filter((p) =>
                    selectedProducts.includes(p.id)
                  );

                  const allActive = selected.every((p) => p.is_active === 1);

                  return (
                    <>
                      {/* BULK TOGGLE */}
                      <button
                        onClick={bulkToggleVisibility}
                        className="
                        flex items-center justify-center
                        w-9 h-9
                        bg-white
                        border border-gray-300
                        rounded-lg
                        shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
                        hover:bg-gray-50
                        transition
                        "
                      >
                        {allActive ? (
                          <FaEye className="text-gray-900 text-sm" />
                        ) : (
                          <FaEyeSlash className="text-gray-400 text-sm" />
                        )}
                      </button>

                      {/* DELETE */}
                      <button
                        onClick={() => setDeleteId("bulk")}
                        className="
                        flex items-center justify-center
                        w-9 h-9
                        bg-white
                        border border-gray-300
                        rounded-lg
                        shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
                        hover:bg-gray-50
                        transition
                        "
                      >
                        <FaTrash className="text-gray-600 text-sm" />
                      </button>
                    </>
                  );
                })()}

  {!searchOpen && (
    <button
onClick={() => setSearchOpen(true)}
className="
flex items-center justify-center gap-1
px-2 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
transition
">
  <FaSearch className="text-gray-600 text-sm" />
  <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
<path
d="M3 5H17M6 10H14M9 15H11"
stroke="#4B5563"
strokeWidth="1.8"
strokeLinecap="round"
/>
</svg>
</button>
  )}
<div className="relative">
  <button
    onClick={() => setSortOpen((v) => !v)}
    className="
          sort-button
          flex items-center justify-center
          w-9 h-9
          bg-white
          border border-gray-300
          rounded-lg
          shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
          hover:bg-gray-50
          active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
          transition
          "
  >
    ⇅
  </button>
</div>
</div>

</div>
                        <table
                            dir={lang === "AR" ? "rtl" : "ltr"}
                            className="w-full min-w-[700px] text-center"
                          >
                            <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                                <tr>

                                  {/* CHECKBOX */}
                                  <th className="px-3 py-2">
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedProducts.length === paginated.length &&
                                        paginated.length > 0
                                      }
                                      onChange={toggleSelectAll}
                                      className="w-4 h-4 accent-gray-800 cursor-pointer"
                                    />
                                  </th>

                                  {/* IMAGE */}
                                  <th className="px-4 py-1.5 text-center">
                                    {TEXT.product}
                                  </th>

                                  {/* CATEGORY */}
                                  <th className="px-4 py-1.5 text-center">
                                    {TEXT.category}
                                  </th>

                                  {/* PRICE */}
                                  <th className="px-4 py-1.5 text-center">
                                    {TEXT.price}
                                  </th>

                                  {/* STOCK */}
                                  <th className="px-4 py-1.5 text-center">
                                    {TEXT.stock}
                                  </th>

                                  {/* ACTIONS */}
                                  <th className="px-4 py-1.5 text-center w-[140px] rounded-tr-[14px]">
                                    {TEXT.status}
                                  </th>

                                </tr>
                                </thead>

                            <tbody>
                                {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="animate-pulse border-b">
      <td className="px-3 py-2">
        <div className="w-4 h-4 bg-gray-200 rounded"></div>
      </td>

      <td className="px-4 py-2">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="h-3 w-32 bg-gray-200 rounded"></div>
        </div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-20 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-16 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-3 w-14 bg-gray-200 rounded mx-auto"></div>
      </td>

      <td className="px-4 py-2">
        <div className="h-5 w-16 bg-gray-200 rounded mx-auto"></div>
      </td>
    </tr>
  ))
) : paginated.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="py-10 text-center">
  <div className="flex flex-col items-center gap-3 text-gray-500">
    
    <FaBoxOpen className="text-[28px] text-gray-300" />

    <div className="text-sm font-medium">
      {TEXT.empty}
    </div>

    <div className="text-xs text-gray-400">
      {lang === "EN"
        ? "Try adjusting filters or add a new product"
        : "حاول تعديل الفلاتر أو إضافة منتج جديد"}
    </div>

  </div>
</td>
                                    </tr>
                                ) : (
                                    paginated.map((p) => {
                                      const base = Number(p.price || 0);
                                      const percent = Number(p.sale_percent || 0);
                                      const hasDiscount = Boolean(p.on_sale) && percent > 0;
                                      const discount = hasDiscount ? (base * percent) / 100 : 0;
                                      const final = hasDiscount ? base - discount : base;

                                      return(
                                        <tr
                                            key={p.id}
                                            onClick={(e) => {
                                              // prevent navigation if clicking inside interactive elements
                                              if (
                                                e.target.closest(".product-trigger") ||
                                                e.target.closest("input") ||
                                                e.target.closest("button")
                                              ) return;

                                              navigate(`/admin/products/edit/${p.id}`);
                                            }}
                                            className="group border-b border-[#f1f1f1] hover:bg-[#f6f6f7] transition cursor-pointer text-[12.5px]"
                                          >
                                            <td
                                                className="px-3 py-1 text-center"
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={selectedProducts.includes(p.id)}
                                                  onChange={() => toggleProductSelection(p.id)}
                                                  className="w-4 h-4 accent-gray-800 cursor-pointer"
                                                />
                                              </td>
                                            <td
                                                className="product-trigger group relative px-2 py-1 w-[280px] max-w-[280px] text-[13px] text-gray-800 text-center cursor-pointer hover:bg-gray-200"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setProductOverlay(p.id === productOverlay?.id ? null : p);
                                                }}
                                              >
                                              <div className="flex items-center gap-3">

                                                {/* IMAGE */}
                                                <ProductMediaThumb
                                                  src={p.image}
                                                  className="w-8 h-8 object-cover rounded bg-gray-100"
                                                />

                                                {/* NAME + ARROW */}
                                                <div className="flex items-center gap-1 font-medium text-gray-900">

                                                  <span className="break-words whitespace-normal">
                                                    {lang === "AR" ? p.name_ar || p.name_en : p.name_en}
                                                  </span>

                                                  <span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
                                                    <FiChevronDown className="text-[18px]" />
                                                  </span>

                                                </div>

                                              </div>
                                              {productOverlay?.id === p.id && (
                                                <div
                                                  className={`
                                                  product-overlay
                                                  absolute
                                                  ${lang === "AR" ? "right-0" : "left-0"}
                                                  top-full
                                                  -mt-1
                                                  w-[280px]
                                                  bg-white
                                                  border border-gray-200
                                                  rounded-[14px]
                                                  shadow-[0_25px_60px_rgba(0,0,0,0.20)]
                                                  z-50
                                                  animate-sortOverlay
                                                  `}
                                                >

                                                  {/* HEADER */}
                                                  <div className="px-4 pt-3 pb-2">

                                                    <div className="text-[15px] font-semibold text-gray-900 leading-tight">
                                                      {lang === "AR" ? p.name_ar || p.name_en : p.name_en}
                                                    </div>

                                                    {p.name_ar && (
                                                      <div className="text-[12.5px] text-gray-500">
                                                        {p.name_ar}
                                                      </div>
                                                    )}

                                                    <div className="text-[12px] text-gray-400 mt-1">
                                                      ID: {p.public_id}
                                                    </div>

                                                  </div>

                                                  {/* CATEGORY */}
                                                  {p.categories?.length > 0 && (
                                                    <div className="px-4 text-[12.5px] text-gray-500">
                                                      {lang === "EN" ? "Collection:" : "الفئة:"}{" "}
                                                      {p.categories
                                                        .map((c) => {
                                                          if (typeof c === "string") {
                                                            const found = categories.find(cat => cat.slug === c);
                                                            return found
                                                              ? (lang === "AR" ? found.name_ar : found.name_en)
                                                              : c;
                                                          }
                                                          return lang === "AR" ? c.name_ar : c.name_en;
                                                        })
                                                        .join(", ")}
                                                    </div>
                                                  )}

                                                  {/* BADGES */}
                                                  <div className="px-4 py-1.5 flex justify-center">
                                                      <div className="flex flex-wrap gap-1">

                                                        {/* NEW */}
                                                        {p.is_new_in ? (
                                                          <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                                                            {TEXT.new}
                                                          </span>
                                                        ) : (
                                                          <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                                            {TEXT.new}
                                                            <span className="absolute inset-0 flex items-center justify-center">
                                                              <span className="w-full h-[1px] bg-green-400 rotate-[-20deg]" />
                                                            </span>
                                                          </span>
                                                        )}

                                                        {/* BESTSELLER */}
                                                        {p.is_bestseller ? (
                                                          <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">
                                                            {TEXT.bestseller}
                                                          </span>
                                                        ) : (
                                                          <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                                            {TEXT.bestseller}
                                                            <span className="absolute inset-0 flex items-center justify-center">
                                                              <span className="w-full h-[1px] bg-purple-400 rotate-[-20deg]" />
                                                            </span>
                                                          </span>
                                                        )}

                                                        {/* SALE */}
                                                        {p.on_sale ? (
                                                          <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded">
                                                            {TEXT.sale} {p.sale_percent}%
                                                          </span>
                                                        ) : (
                                                          <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                                            {TEXT.sale}
                                                            <span className="absolute inset-0 flex items-center justify-center">
                                                              <span className="w-full h-[1px] bg-red-400 rotate-[-20deg]" />
                                                            </span>
                                                          </span>
                                                        )}

                                                      </div>
                                                    </div>

                                                  <div className="border-t border-gray-200"></div>

                                                  {/* VIEW BUTTON */}
                                                  <div className="p-2">
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(`/admin/products/edit/${p.id}`);
                                                      }}
                                                      className="
                                                      w-full
                                                      flex items-center justify-center gap-2
                                                      h-[34px]
                                                      bg-[#f6f6f7]
                                                      border border-gray-300
                                                      rounded-lg
                                                      text-[13px] font-medium text-gray-800
                                                      shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
                                                      hover:bg-gray-100
                                                      active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
                                                      transition
                                                      "
                                                    >
                                                      <FaEye className="text-[12px] text-gray-600" />
                                                      {lang === "EN" ? "View product" : "عرض المنتج"}
                                                    </button>
                                                  </div>

                                                </div>
                                              )}
                                            </td>

                                     <td className="px-4 py-1 text-[13px] text-gray-900 text-center">
  {p.categories?.length > 0 ? (
    <div className="flex flex-wrap justify-center gap-2">
      {p.categories.slice(0, 2).map((c, i) => {
        let label = "";

        if (typeof c === "string") {
          // 🔥 map slug → category object
          const found = categories.find(cat => cat.slug === c);
          label = found
            ? (lang === "AR" ? found.name_ar : found.name_en)
            : c;
        } else {
          label =
            lang === "AR"
              ? c.name_ar || c.name_en
              : c.name_en;
        }

        return (
          <span key={i} className="text-center">
            {label}
          </span>
        );
      })}

      {p.categories.length > 2 && (
        <span className="text-gray-400 text-[11px]">
          +{p.categories.length - 2}
        </span>
      )}
    </div>
  ) : (
    <span className="text-gray-300 text-xs">
      {lang === "EN" ? "No Collection" : "بدون فئة"}
    </span>
  )}
</td>

                                         <td
                                              className={`price-trigger relative px-3 py-1 align-middle text-center ${
                                                hasDiscount ? "cursor-pointer" : "cursor-pointer"
                                              }`}
                                              onMouseEnter={() => {
                                                if (!hasDiscount) return;
                                                clearTimeout(window.priceHoverTimeout);
                                                setPriceOverlay(p);
                                              }}
                                              onMouseLeave={() => {
                                                if (!hasDiscount) return;
                                                window.priceHoverTimeout = setTimeout(() => {
                                                  setPriceOverlay(null);
                                                }, 120);
                                              }}
                                            >
                                              <div className="flex items-center justify-center gap-2">
                                                <span className="font-semibold text-gray-900">
                                                  ${final.toFixed(2)}
                                                </span>

                                                {hasDiscount ? (
                                                  <span className="
                                                    inline-flex items-center justify-center
                                                    px-2.5 py-[2px]
                                                    rounded-md
                                                    text-[11px] font-medium
                                                   
                                                    bg-red-50 text-red-700 
                                                  ">
                                                    {percent}% OFF
                                                  </span>
                                                ) : null}
                                              </div>

                                              {hasDiscount && priceOverlay?.id === p.id ? (
                                                <div
                                                  className="
                                                    price-overlay
                                                    absolute
                                                    left-1/2 -translate-x-1/2
                                                    top-full
                                                    pt-2
                                                    w-[240px]
                                                    bg-white
                                                    border border-gray-200
                                                    rounded-[14px]
                                                    shadow-[0_25px_60px_rgba(0,0,0,0.20)]
                                                    z-50
                                                    animate-sortOverlay
                                                  "
                                                >
                                                  <div className="px-4 pt-3 pb-2 border-b">
                                                    <div className="text-sm font-semibold text-gray-900">
                                                      {TEXT.priceDetails}
                                                    </div>
                                                  </div>

                                                  <div className="px-4 py-3 space-y-2 text-sm">
                                                    <div className="flex justify-between text-gray-500">
                                                      <span>{TEXT.basePrice}</span>
                                                      <span>${base.toFixed(2)}</span>
                                                    </div>

                                                    <div className="flex justify-between text-gray-500">
                                                      <span>{TEXT.discount}</span>
                                                      <span>-{percent}%</span>
                                                    </div>

                                                    <div className="flex justify-between text-red-600 font-medium">
                                                      <span>{TEXT.amountSaved}</span>
                                                      <span>-${discount.toFixed(2)}</span>
                                                    </div>

                                                    <div className="border-t pt-2 flex justify-between font-semibold text-gray-900">
                                                      <span>{TEXT.finalPrice}</span>
                                                      <span>${final.toFixed(2)}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}

                                              {/* PRICE OVERLAY */}
                                            {hasDiscount && priceOverlay?.id === p.id && (() => {
                                              const base = Number(p.price || 0);
                                              const percent = Number(p.sale_percent || 0);
                                              const discount = (base * percent) / 100;
                                              const final = base - discount;

                                              return (
                                                <div
                                                  className="
                                                  price-overlay
                                                  absolute
                                                  left-1/2 -translate-x-1/2
                                                  top-full
                                                  pt-2
                                                  w-[240px]
                                                  bg-white
                                                  border border-gray-200
                                                  rounded-[14px]
                                                  shadow-[0_25px_60px_rgba(0,0,0,0.20)]
                                                  z-50
                                                  animate-sortOverlay
                                                  "
                                                >
                                                  {/* HEADER */}
                                                  <div className="px-4 pt-3 pb-2 border-b">
                                                    <div className="text-sm font-semibold text-gray-900">
                                                      {TEXT.priceDetails}
                                                    </div>
                                                  </div>

                                                  {/* CONTENT */}
                                                  <div className="px-4 py-3 space-y-2 text-sm">
                                                    <div className="flex justify-between text-gray-500">
                                                      <span>{TEXT.basePrice}</span>
                                                      <span>${base.toFixed(2)}</span>
                                                    </div>

                                                    <div className="flex justify-between text-gray-500">
                                                      <span>{TEXT.discount}</span>
                                                      <span>-{percent}%</span>
                                                    </div>

                                                    <div className="flex justify-between text-red-600 font-medium">
                                                      <span>{TEXT.amountSaved}</span>
                                                      <span>-${discount.toFixed(2)}</span>
                                                    </div>

                                                    <div className="border-t pt-2 flex justify-between font-semibold text-gray-900">
                                                      <span>{TEXT.finalPrice}</span>
                                                      <span>${final.toFixed(2)}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })()}
                                            </td>


                                         <td
                                              className="relative px-3 py-1 align-middle text-center cursor-pointer"
                                              onMouseEnter={() => {
                                                clearTimeout(window.stockHoverTimeout);
                                                setStockOverlay(p);
                                              }}
                                              onMouseLeave={(e) => {
                                                if (
                                                  e.relatedTarget &&
                                                  e.relatedTarget instanceof Node &&
                                                  e.currentTarget.contains(e.relatedTarget)
                                                ) return;
                                                if (isHoveringOverlay) return;

                                                window.stockHoverTimeout = setTimeout(() => {
                                                  setStockOverlay(null);
                                                }, 200);
                                              }}
                                            >
                                              {(() => {
                                                const colors = groupVariantsByColor(p.variants);
                                                const total = colors.reduce((sum, c) => sum + c.total, 0);

                                                const isOut = total === 0;
                                                const isLow = total > 0 && total <= 3;

                                                return (
                                                  <div className="flex justify-center">
                                                    {isOut ? (
                                                      <span className="
                                                        inline-flex items-center justify-center
                                                        px-2.5 py-[2px]
                                                        rounded-md
                                                        text-[11px] font-medium
                                                        bg-red-50 text-red-700
                                                      ">
                                                        {lang === "EN" ? "Out of stock" : "نفذ المخزون"}
                                                      </span>
                                                    ) : isLow ? (
                                                      <span className="
                                                        inline-flex items-center justify-center
                                                        px-2.5 py-[2px]
                                                        rounded-md
                                                        text-[11px] font-medium
                                                        bg-amber-50 text-amber-700
                                                      ">
                                                        {total} {lang === "EN" ? "left" : "متبقي"}
                                                      </span>
                                                    ) : (
                                                      <span className="text-sm font-semibold text-gray-900">
                                                        {total} {lang === "EN" ? "in stock" : "متوفر"}
                                                      </span>
                                                    )}
                                                  </div>
                                                );
                                              })()}

                                              {/* OVERLAY */}
                                              {stockOverlay?.id === p.id && (() => {
                                                const colors = groupVariantsByColor(p.variants);
                                                const total = colors.reduce((sum, c) => sum + c.total, 0);

                                                return (
                                                  <div
                                                    className="
                                                        absolute
                                                        left-1/2 -translate-x-1/2
                                                        top-full
                                                        pt-2
                                                        w-[260px]
                                                        bg-white
                                                        border border-gray-200
                                                        rounded-[14px]
                                                        shadow-[0_25px_60px_rgba(0,0,0,0.20)]
                                                        z-50
                                                        animate-sortOverlay
                                                        "
                                                  >
                                                    {/* HEADER */}
                                                    <div className="px-4 pt-3 pb-2 border-b">
                                                      <div className="text-sm font-semibold text-gray-900">
                                                        {TEXT.stockDetails}
                                                      </div>
                                                      <div className="text-xs text-gray-500">
                                                        {TEXT.total}: {total}
                                                      </div>
                                                    </div>

                                                    {/* CONTENT */}
                                                    <div className="px-4 py-3 space-y-3 text-xs">
                                                      {colors.length === 0 ? (
                                                        <div className="text-gray-400 text-center">
                                                          {TEXT.noStock}
                                                        </div>
                                                      ) : (() => {
                                                        const pageIndex = expandedStock[p.id] || 0;
                                                        const visibleColors = colors.slice(pageIndex * 3, (pageIndex + 1) * 3);

                                                        return visibleColors.map((c, i) => (
                                                          <div key={i}>
                                                            {/* COLOR HEADER */}
                                                            <div className="flex items-center justify-between mb-1">
                                                              <div className="flex items-center gap-2">
                                                                <span
                                                                  className="w-3 h-3 rounded-full border"
                                                                  style={{ backgroundColor: c.color_hex }}
                                                                />
                                                                <span className="font-semibold">
                                                                  {c.color_name}
                                                                </span>
                                                              </div>

                                                              <span className="text-gray-500">
                                                                {c.total}
                                                              </span>
                                                            </div>

                                                            {/* SIZES */}
                                                            <div className="flex flex-wrap gap-2">
                                                              {c.sizes.map((s, j) => (
                                                                <span
                                                                  key={j}
                                                                  className="px-2 py-0.5 border rounded-full bg-gray-50"
                                                                >
                                                                  {s.size}: {s.qty}
                                                                </span>
                                                              ))}
                                                            </div>
                                                          </div>
                                                        ));
                                                      })()}
                                                    </div>
                                                      {colors.length > 3 && (() => {
                                                        const pageIndex = expandedStock[p.id] || 0;
                                                        const maxPages = Math.ceil(colors.length / 3);

                                                        const isFirst = pageIndex === 0;
                                                        const isLast = pageIndex === maxPages - 1;

                                                        return (
                                                          <div className="flex justify-center items-center gap-2 pt-2 mb-2">

                                                            {/* UP */}
                                                            <button
                                                              disabled={isFirst}
                                                              onClick={(e) => {
                                                                e.stopPropagation();

                                                                setExpandedStock((prev) => ({
                                                                  ...prev,
                                                                  [p.id]: Math.max((prev[p.id] || 0) - 1, 0),
                                                                }));
                                                              }}
                                                              className={`
                                                                w-7 h-7 flex items-center justify-center
                                                                rounded-md border text-xs
                                                                transition
                                                                ${
                                                                  isFirst
                                                                    ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                                                                    : "bg-white hover:bg-gray-50 text-gray-900 shadow-sm"
                                                                }
                                                              `}
                                                            >
                                                              ↑
                                                            </button>

                                                            {/* DOWN */}
                                                            <button
                                                              disabled={isLast}
                                                              onClick={(e) => {
                                                                e.stopPropagation();

                                                                setExpandedStock((prev) => ({
                                                                  ...prev,
                                                                  [p.id]: Math.min((prev[p.id] || 0) + 1, maxPages - 1),
                                                                }));
                                                              }}
                                                              className={`
                                                                w-7 h-7 flex items-center justify-center
                                                                rounded-md border text-xs
                                                                transition
                                                                ${
                                                                  isLast
                                                                    ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                                                                    : "bg-white hover:bg-gray-50 text-gray-900 shadow-sm"
                                                                }
                                                              `}
                                                            >
                                                              ↓
                                                            </button>

                                                          </div>
                                                        );
                                                      })()}
                                                    <div className="border-t"></div>

                                                    {/* BUTTON */}
                                                    <div className="p-2">
                                                      <button
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          navigate(`/admin/products/edit/${p.id}`);
                                                        }}
                                                        className="
                                                        w-full
                                                        flex items-center justify-center gap-2
                                                        h-[34px]
                                                        bg-[#f6f6f7]
                                                        border border-gray-300
                                                        rounded-lg
                                                        text-[13px] font-medium text-gray-800
                                                        shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
                                                        hover:bg-gray-100
                                                        active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
                                                        transition
                                                        "
                                                      >
                                                        <FaEdit className="text-[12px]" />
                                                        {TEXT.editStock}
                                                      </button>
                                                    </div>
                                                  </div>
                                                );
                                              })()}
                                            </td>



                                            <td className="px-3 py-1 text-center w-[140px]">
                                              <div className="flex items-center justify-center gap-2">

                                                {/* STATUS BADGE */}
                                                <span
                                                  className={`
                                                    text-[11px] font-medium px-2.5 py-[2px] rounded-md 
                                                    ${
                                                      p.is_active
                                                        ? "bg-green-50 text-green-700"
                                                        : "bg-blue-50 text-blue-700"
                                                    }
                                                  `}
                                                >
                                                  {p.is_active
                                                    ? TEXT.active
                                                    : TEXT.hidden}
                                                </span>

                                                {/* TOGGLE BUTTON */}
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleToggleVisibility(p.id);
                                                  }}
                                                  className={`
                                                    opacity-0 group-hover:opacity-100
                                                    transition
                                                    w-7 h-7 flex items-center justify-center
                                                    rounded-md
                                                    bg-white border border-gray-300
                                                    shadow-sm
                                                    hover:bg-gray-50
                                                  `}
                                                >
                                                  {p.is_active ? (
                                                    <FaEye className="text-gray-900 text-[15px]" />
                                                  ) : (
                                                    <FaEyeSlash className="text-gray-400 text-[15px]" />
                                                  )}
                                                </button>

                                              </div>
                                            </td>
                                        </tr>
                                      );
                                  })
                                )}
                            </tbody>

                              <tfoot>
                              <tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
                              <td
                                colSpan="6"
                                className={`px-4 py-1 ${lang === "EN" ? "rounded-br-[14px] rounded-bl-[14px]" : "rounded-bl-[14px] rounded-br-[14px]"}`}
                              >

                              <div className={`flex items-center justify-between text-sm text-gray-600 ${lang === "AR" ? "flex-row-reverse" : ""}`}>

                                {/* PRODUCT COUNT */}
                                <span className="text-gray-500 text-sm">
                                  {filtered.length} {lang === "EN" ? "products" : "منتجات"}
                                </span>

                                {/* PAGINATION */}
                                <div className="flex items-center gap-0.5">

                                  {/* PREV */}
                                  <button
                                    onClick={() => goToPage((p) => Math.max(1, p - 1))}
                                    disabled={page === 1}
                                    className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200
                                    ${
                                      page === 1
                                        ? "opacity-40 cursor-not-allowed"
                                        : "hover:bg-gray-300"
                                    }`}
                                  >
                                    {"<"}
                                  </button>

                                  {/* NEXT */}
                                  <button
                                    onClick={() => goToPage((p) => Math.min(totalPages, p + 1))}
                                    disabled={page === totalPages}
                                    className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200
                                    ${
                                      page === totalPages
                                        ? "opacity-40 cursor-not-allowed"
                                        : "hover:bg-gray-300"
                                    }`}
                                  >
                                    {">"}
                                  </button>

                                  {/* PAGE INFO */}
                                  <span className="mx-2 text-gray-600 font-bold">
                                    {page}-{totalPages}
                                  </span>

                                </div>

                              </div>

                              </td>
                              </tr>
                              </tfoot>

                              </table>
                    </div>

                    {/* MOBILE SECTION */}
<div className="md:hidden">

  {/* 🔥 FILTER BAR (SHOPIFY STYLE) */}
  <div className="bg-white border border-gray-200 rounded-xl p-3 mb-3 shadow-sm space-y-3">

{categoryOpen && (
  <div className="fixed inset-0 z-[9999] bg-black/30 flex items-end">
    <div className="w-full bg-white rounded-t-2xl max-h-[70vh] overflow-y-auto animate-fadeSlide">

      <div className="p-4 border-b font-semibold text-sm">
        {lang === "EN" ? "Filter by Collection" : "تصفية حسب الفئة"}
      </div>

      <button
        onClick={() => {
          setCategoryFilter(null);
          setCategoryOpen(false);
        }}
        className="w-full text-left px-4 py-3 text-sm border-b"
      >
        {lang === "EN" ? "All Collections" : "كل الفئات"}
      </button>

      {categories.map((c) => (
        <button
          key={c.id}
          onClick={() => {
            setCategoryFilter(c.slug);
            setCategoryOpen(false);
            goToPage(1);
          }}
          className="w-full text-left px-4 py-3 text-sm border-b"
        >
          {lang === "AR" ? c.name_ar : c.name_en}
        </button>
      ))}
    </div>
  </div>
)}

{sortOpen && (
  <div className="fixed inset-0 z-[9999] bg-black/30 flex items-end">
    <div className="w-full bg-white rounded-t-2xl p-4 space-y-3 animate-fadeSlide">

      <div className="font-semibold text-sm mb-2">
        {TEXT.sortBy}
      </div>

      {[
        { label: TEXT.titleCol, value: "title_en" },
        { label: TEXT.price, value: "price" },
        { label: TEXT.stock, value: "stock" },
      ].map((opt) => (
        <label key={opt.value} className="flex items-center gap-3 text-sm">
          <input
            type="radio"
            checked={sortField === opt.value}
            onChange={() => setSortField(opt.value)}
            className="accent-gray-800"
          />
          {opt.label}
        </label>
      ))}

      <div className="border-t pt-3 flex flex-col gap-2">

        <button
          onClick={() => {
  setSortBy(null); // 🔥 force reset first
  setTimeout(() => {
    setSortBy(sortField);
    setSortDirection("asc");
  }, 0);
  setSortOpen(false);
}}
          className="py-2 text-sm bg-gray-100 rounded-md"
        >
          ↑ {sortField === "price" || sortField === "stock"
            ? TEXT.lowestToHighest
            : TEXT.aToZ}
        </button>

        <button
          onClick={() => {
  setSortBy(null);
  setTimeout(() => {
    setSortBy(sortField);
    setSortDirection("desc");
  }, 0);
  setSortOpen(false);
}}
          className="py-2 text-sm bg-gray-100 rounded-md"
        >
          ↓ {sortField === "price" || sortField === "stock"
            ? TEXT.highestToLowest
            : TEXT.zToA}
        </button>

      </div>

    </div>
  </div>
)}

    {/* SEARCH */}
    <div className="flex items-center gap-2 border rounded-lg px-3 h-10">
      <FaSearch className="text-gray-400 text-sm" />
      <input
        type="text"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          goToPage(1);
        }}
        placeholder={TEXT.search}
        className="flex-1 outline-none text-sm"
      />
    </div>

    {/* FILTERS */}
    <div className="flex items-center gap-2 flex-wrap">

      {[
        { label: TEXT.all, value: "All" },
        { label: TEXT.active, value: "active" },
        { label: TEXT.hidden, value: "hidden" },
      ].map((f) => {
        const active = visibilityFilter === f.value;

        return (
          <button
            key={f.value}
            onClick={() => {
              setVisibilityFilter(f.value);
              goToPage(1);
            }}
            className={`px-3 py-1 text-xs rounded-md ${
              active
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-900"
            }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>

    {/* COUNT */}
    <div className="text-xs text-gray-500">
      {filtered.length} {lang === "EN" ? "products" : "منتجات"}
    </div>
  </div>
            {loading ? (
  [...Array(4)].map((_, i) => (
    <div key={i} className="bg-white rounded-xl shadow p-4 mb-3 animate-pulse">
      
      <div className="flex items-center gap-3 mb-3">
        <div className="w-16 h-16 bg-gray-200 rounded"></div>
        <div className="space-y-2">
          <div className="h-3 w-32 bg-gray-200 rounded"></div>
          <div className="h-2 w-20 bg-gray-100 rounded"></div>
        </div>
      </div>

      <div className="h-3 w-full bg-gray-100 rounded mb-2"></div>
      <div className="h-3 w-2/3 bg-gray-100 rounded"></div>

    </div>
  ))
) : paginated.length === 0 ? (
            <div className="text-center py-10 text-gray-500 flex flex-col items-center gap-3">
  <FaBoxOpen className="text-[26px] text-gray-300" />
  
  <div className="text-sm font-medium">
    {TEXT.empty}
  </div>

  <div className="text-xs text-gray-400">
    {lang === "EN"
      ? "Try adjusting filters or add a product"
      : "حاول تعديل الفلاتر أو إضافة منتج"}
  </div>
</div>
            ) : (
              paginated.map((p) => (
                <div
                  key={p.id}
                  className="bg-white rounded-xl shadow p-4 space-y-3 mb-3"
                >
                  {/* Header */}
                  <div className="flex items-center gap-3">
                    <ProductMediaThumb
                      src={p.image}
                      className="w-16 h-16 rounded object-cover bg-gray-100"
                    />
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="font-bold">
                        {p.name_en}
                      </span>

                      {!p.is_active && (
                        <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded">
                          {TEXT.hidden}
                        </span>
                      )}
                    </div>
                  <div className="text-xs text-gray-400">ID: {p.public_id}</div>
                  {p.name_ar && (
                    <div className="text-xs text-gray-500">{p.name_ar}</div>
                  )}
                </div>
              </div>

                <div className="text-xs text-gray-500">
                  {(() => {
                    if (!p.categories?.length) {
                      return lang === "EN" ? "No collection" : "بدون فئة";
                    }

                    const c = p.categories[0];

                    if (typeof c === "string") {
                      const found = categories.find(cat => cat.slug === c);
                      return found
                        ? (lang === "AR" ? found.name_ar : found.name_en)
                        : c;
                    }

                    return lang === "AR" ? c.name_ar : c.name_en;
                  })()}
                </div>

                        {/* Price */}
                        <div className="flex justify-between text-sm">
                  <span>{TEXT.price}</span>

                  {!(p.on_sale && Number(p.sale_percent || 0) > 0) ? (
                    <span className="font-bold">${Number(p.price).toFixed(2)}</span>
                  ) : (
                    <div className="text-right">
                      <div className="text-xs text-gray-500 line-through">
                        ${Number(p.price).toFixed(2)}
                      </div>
                      <div className="text-xs font-bold text-red-600">
                        -{p.sale_percent}%
                      </div>
                      <div className="font-bold text-green-600">
                        $
                        {(
                          Number(p.price) -
                          (Number(p.price) * Number(p.sale_percent || 0)) / 100
                        ).toFixed(2)}
                      </div>
                    </div>
                  )}
                </div>


                    {/* Stock */}
                    <div>
                          <div>
                          {(() => {
                            const colors = groupVariantsByColor(p.variants);
                            const total = colors.reduce((sum, c) => sum + c.total, 0);
                            const isOpen = expandedStock[p.id];

                            return (
                              <>
                                {/* HEADER */}
                                <div className="flex items-center justify-between">
                                  <div className="text-sm font-semibold">
                                    {TEXT.stock}: {total}
                                  </div>

                                  <button
                                    onClick={() =>
                                      setExpandedStock((prev) => ({
                                        ...prev,
                                        [p.id]: !prev[p.id],
                                      }))
                                    }
                                    className="text-xs text-blue-600 font-medium"
                                  >
                                    {isOpen
                                      ? lang === "EN" ? "Hide details" : "إخفاء التفاصيل"
                                      : lang === "EN" ? "See variants" : "عرض التفاصيل"}
                                  </button>
                                </div>

                                {/* COLLAPSIBLE */}
                                {isOpen && (
                                  <div className="mt-3 space-y-2">
                                    {colors.map((c, i) => (
                                      <div key={i} className="border rounded-lg p-2 bg-gray-50">

                                        <div className="flex items-center gap-2 text-sm font-semibold mb-1">
                                          <span
                                            className="w-3 h-3 rounded-full border"
                                            style={{ backgroundColor: c.color_hex }}
                                          />
                                          {c.color_name}
                                          <span className="text-xs text-gray-500">
                                            ({c.total})
                                          </span>
                                        </div>

                                        <div className="flex flex-wrap gap-2 text-xs">
                                          {c.sizes.map((s, j) => (
                                            <span
                                              key={j}
                                              className="px-2 py-0.5 border rounded-full bg-white"
                                            >
                                              {s.size}: {s.qty}
                                            </span>
                                          ))}
                                        </div>

                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                        </div>


                                      {/* Bottom row: badges on the left + actions on the right */}
                              <div className="flex items-start justify-between gap-3 pt-2 border-t">
                                {/* Badges (same style as desktop) */}
                                <div className="flex flex-wrap gap-1">
                                  {p.on_sale ? (
                                    <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded">
                                      {TEXT.sale} {p.sale_percent}%
                                    </span>
                                  ) : (
                                    <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                      {TEXT.sale}
                                      <span className="absolute inset-0 flex items-center justify-center">
                                        <span className="w-full h-[1px] bg-red-400 rotate-[-20deg]" />
                                      </span>
                                    </span>
                                  )}

                                  {p.is_bestseller ? (
                                    <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">
                                      {TEXT.bestseller}
                                    </span>
                                  ) : (
                                    <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                      {TEXT.bestseller}
                                      <span className="absolute inset-0 flex items-center justify-center">
                                        <span className="w-full h-[1px] bg-purple-400 rotate-[-20deg]" />
                                      </span>
                                    </span>
                                  )}

                                  {p.is_new_in ? (
                                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                                      {TEXT.new}
                                    </span>
                                  ) : (
                                    <span className="relative text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded">
                                      {TEXT.new}
                                      <span className="absolute inset-0 flex items-center justify-center">
                                        <span className="w-full h-[1px] bg-green-400 rotate-[-20deg]" />
                                      </span>
                                    </span>
                                  )}
                                </div>
                              {/* Actions */}
                              <div className="flex gap-4 items-center">
                                {/* Visibility toggle */}
                                <button
                                  className={p.is_active ? "text-green-600" : "text-gray-400"}
                                  title={p.is_active ? "Hide product" : "Make visible"}
                                  onClick={() => handleToggleVisibility(p.id)}
                                >
                                  {p.is_active ? <FaEye /> : <FaEyeSlash />}
                                </button>

                                {/* Edit */}
                                <button
                                  className="text-blue-600"
                                  onClick={() => navigate(`/admin/products/edit/${p.id}`)}
                                >
                                  <FaEdit />
                                </button>

                                {/* Delete */}
                                <button
                                  className="text-red-600"
                                  onClick={() => setDeleteId(p.id)}
                                >
                                  <FaTrash />
                                </button>
                              </div>

                              </div>

                                    </div>
                                  ))
                                )}
                              </div>




  {/* MOBILE PAGINATION — desktop behavior remains unchanged */}
  {totalPages > 1 && (
    <div
      dir="ltr"
      className="
        mt-4 mb-5
        bg-white
        border border-gray-200
        rounded-xl
        shadow-sm
        px-3 py-3
      "
    >
      <div className="flex items-center justify-between gap-3">
        {/* PREVIOUS */}
        <button
          type="button"
          onClick={() => goToPage((current) => Math.max(1, current - 1))}
          disabled={page <= 1}
          className={`
            min-w-[96px]
            h-10
            px-3
            rounded-lg
            border
            text-sm font-semibold
            flex items-center justify-center gap-2
            transition
            ${
              page <= 1
                ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                : "bg-white text-gray-900 border-gray-300 hover:bg-gray-100 active:bg-gray-200"
            }
          `}
        >
          <span aria-hidden="true">‹</span>
          <span>{TEXT.prev}</span>
        </button>

        {/* CURRENT PAGE */}
        <div className="text-center min-w-0">
          <div className="text-sm font-bold text-gray-900">
            {page} / {Math.max(totalPages, 1)}
          </div>

          <div className="mt-0.5 text-[11px] text-gray-500 whitespace-nowrap">
            {lang === "EN"
              ? `Page ${page} of ${Math.max(totalPages, 1)}`
              : `الصفحة ${page} من ${Math.max(totalPages, 1)}`}
          </div>
        </div>

        {/* NEXT */}
        <button
          type="button"
          onClick={() =>
            goToPage((current) =>
              Math.min(Math.max(totalPages, 1), current + 1)
            )
          }
          disabled={page >= Math.max(totalPages, 1)}
          className={`
            min-w-[96px]
            h-10
            px-3
            rounded-lg
            border
            text-sm font-semibold
            flex items-center justify-center gap-2
            transition
            ${
              page >= Math.max(totalPages, 1)
                ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                : "bg-white text-gray-900 border-gray-300 hover:bg-gray-100 active:bg-gray-200"
            }
          `}
        >
          <span>{TEXT.next}</span>
          <span aria-hidden="true">›</span>
        </button>
      </div>

      <div className="mt-3 text-center text-xs text-gray-500">
        {filtered.length} {lang === "EN" ? "products" : "منتجات"}
      </div>
    </div>
  )}

                    {deleteId !== null && (
                        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
                            <div className="bg-white p-6 rounded-xl shadow-xl w-80">
                                <h2 className="text-lg font-bold text-red-600 mb-2">
                                    {TEXT.deleteTitle}
                                </h2>
                                <p className="mb-5">
                                      {deleteId === "bulk"
                                        ? TEXT.bulkDeleteText
                                        : TEXT.deleteText}
                                    </p>

                                <div className="flex justify-end gap-3">
                                    <button
                                        className="px-4 py-2 bg-gray-300 rounded-lg"
                                        onClick={() => setDeleteId(null)}
                                    >
                                        {TEXT.cancel}
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-red-500 text-white rounded-lg"
                                        onClick={() => {
                                                if (deleteId === "bulk") {
                                                  confirmBulkDelete();
                                                } else {
                                                  confirmDelete();
                                                }
                                              }}
                                    >
                                        {TEXT.delete}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                 </>
  )}

  {showToast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">
    <div className="
      flex items-center gap-3
      px-4 py-3
      bg-white
      border border-gray-200
      rounded-[12px]
      shadow-[0_10px_30px_rgba(0,0,0,0.12)]
    ">

      <div className="
        flex items-center justify-center
        w-7 h-7
        rounded-full
        bg-green-100
      ">
        <span className="text-green-700 text-sm">✓</span>
      </div>

      <div className="text-sm text-gray-800 font-medium">
        {toastMessage}
      </div>

    </div>
  </div>
)}

</main>
            </div>
        </div>
    );
}

export default AdminProducts;
